import { withLatestFrom } from 'rxjs/operators/withLatestFrom';
import { filter } from 'rxjs/operators/filter';
import { mergeMap } from 'rxjs/operators/mergeMap';
import get from 'lodash.get';

import { PUSH } from '../../actions/errors';
import { SYNC_ROUTE } from '../../actions/routes';
import CustomerCheckQuery from '../../graphql/CustomerCheckQuery';
import { RECEIVE_PAYMENT_RESPONSE } from '../../actions/transaction';

const whenError = (...errors) => (action$) =>
  action$.ofType(PUSH).pipe(filter(({ id }) => errors.includes(id)));

const whileOnRoute = (epicAction$, ...routes) => (action$) =>
  action$.pipe(
    withLatestFrom(epicAction$.ofType(SYNC_ROUTE)),
    filter(([, route]) => {
      if (!routes.length) {
        return true;
      }

      return routes.includes(route.match.path);
    })
  );

const whenLoggedInCustomerIsInCohort = (apolloClient) => (action$) =>
  action$.pipe(
    mergeMap(() =>
      apolloClient
        .query({
          query: CustomerCheckQuery,
        })
        .then(
          (response) => response,
          () => null
        )
    ),
    filter((response) => get(response, 'data.user.customer.isInCohort', false))
  );

const withPaymentResponse = (...actions) => (action$) =>
  action$
    .ofType(RECEIVE_PAYMENT_RESPONSE)
    .pipe(filter(({ action }) => actions.includes(action)));

const withPendingStatus = (...statusTypes) => (action$) =>
  action$.pipe(
    withPaymentResponse('pending'),
    filter((response) => statusTypes.includes(response.data.status))
  );

export {
  whenError,
  whileOnRoute,
  whenLoggedInCustomerIsInCohort,
  withPaymentResponse,
  withPendingStatus,
};
